module.exports = __webpack_public_path__ + "img/jiaofei-ok.6d88f758.jpg";